import de from 'date-fns/locale/de';
import add from 'date-fns/add';
import sub from 'date-fns/sub';
import set from 'date-fns/set';
import startOfHour from 'date-fns/startOfHour';
import startOfMinute from 'date-fns/startOfMinute';
import getTime from 'date-fns/getTime';
import getMinutes from 'date-fns/getMinutes';
import getHours from 'date-fns/getHours';
import getDate from 'date-fns/getDate';
import getMonth from 'date-fns/getMonth';
import getYear from 'date-fns/getYear';
import format from 'date-fns/format';
import isAfter from 'date-fns/isAfter';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'

export default {
    add,
    sub,
    set,
    differenceInCalendarDays,
    
    getTime, //Get the milliseconds timestamp of the given date
    getMinutes,
    getHours,
    getDate,
    getMonth,
    getYear,

    startOfMinute,
    startOfHour,
    startOfDay,
    endOfDay,

    isAfter,
    
    locale: de,
    format: function (date, formatStr){
        return format(date, formatStr, { locale: de });
    }
};



// WEBPACK FOOTER //
// ./js/datefns.js